export const skechers = [
  { image: "/images/skechers/1.jpg" },
  { image: "/images/skechers/2.jpg" },
  { image: "/images/skechers/3.jpg" },
];
